<!-- tenant-modal.component.html -->
<div class="modal fade" [class.show]="isVisible" [class.d-block]="isVisible" tabindex="-1"
  aria-labelledby="tenantModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="tenantModalLabel">{{title}}</h5>
        <button type="button" class="btn-close text-white" aria-label="Close" (click)="close()"></button>
      </div>
      <div class="modal-body">
        <div class="tenant-list">
          <ng-container *ngIf="tenants && tenants.length > 0; else noTenants">
            <div class="tenant-items">
              <div *ngFor="let tenant of tenants" class="tenant-item">
                {{ tenant }}
              </div>
            </div>
          </ng-container>
          <ng-template #noTenants>
            <div class="no-tenants">No tenant information available</div>
          </ng-template>
        </div>
      </div>
    </div>
  </div>
</div>
